__turbopack_context__.v({
  "J": "style-module-scss-module__VAsjqW__J",
  "U": "style-module-scss-module__VAsjqW__U",
  "activeLetter": "style-module-scss-module__VAsjqW__activeLetter",
  "bold": "style-module-scss-module__VAsjqW__bold",
  "component": "style-module-scss-module__VAsjqW__component",
  "content-container": "style-module-scss-module__VAsjqW__content-container",
  "down-arrow": "style-module-scss-module__VAsjqW__down-arrow",
  "down-arrow-container": "style-module-scss-module__VAsjqW__down-arrow-container",
  "hero-quote-container": "style-module-scss-module__VAsjqW__hero-quote-container",
  "jumpInfinite": "style-module-scss-module__VAsjqW__jumpInfinite",
  "slideDownUp": "style-module-scss-module__VAsjqW__slideDownUp",
  "video-container": "style-module-scss-module__VAsjqW__video-container",
  "visible": "style-module-scss-module__VAsjqW__visible",
});
